// extracted by mini-css-extract-plugin
export default {"image_container":"CartItemImage_image_container__xcc5w"};